module.exports = __webpack_public_path__ + "img/car_27.fe9e1ec8.jpg";